module.exports = __webpack_public_path__ + "img/quest_icon_0002_archer.eb0413e0.png";